import { render, staticRenderFns } from "./fancyText.vue?vue&type=template&id=5e01725f"
import script from "./fancyText.vue?vue&type=script&lang=js"
export * from "./fancyText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports